<template>
  <div class="title-bar">
    <div class="company-name d-flex align-items-center">
      <ol class="breadcrumb page-breadcrumb">
        <li class="breadcrumb-item" v-for="breadcrumb in breadcrumbsMapped" :key="breadcrumb.id">
          <router-link class="breadcrumb-name" :to="breadcrumb.to">{{ breadcrumb.name }}</router-link>
        </li>
      </ol>
    </div>

    <button v-if="hasChildren" class="exit-btn" @click="goBackToHome">
      <font-awesome-icon class="icon" :icon="['fal', 'times']" />
    </button>

    <b-button
      v-if="!hasChildren"
      variant="primary"
      class="to-dashboard"
      v-b-modal.add-division-modal
      @click="goToDashboard"
    >
      View dashboard
      <font-awesome-icon class="icon" :icon="['fas', 'arrow-right']" />
    </b-button>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router/composables';
import { computed } from 'vue';
import useTalentPoolLocations from '@/state/composables/useTalentPoolLocations';

const router = useRouter();

const props = defineProps({
  breadcrumbs: Array,
  entityId: String,
  hasChildren: Boolean,
});

const { locations, getLocations } = useTalentPoolLocations();

const breadcrumbsMapped = computed(() => {
  return props.breadcrumbs.map(crumb => {
    return { name: crumb.name, to: `/fw/${crumb.entity_id}/settings` };
  });
});

const goBackToHome = async () => {
  if (locations.value.length > 0) {
    const firstLocationId = locations.value[0].location_id;
    router.push({ name: 'talent-pool', params: { locationId: firstLocationId } });
  } else {
    await getLocations();
  }
};

const goToDashboard = () => {
  router.push({
    name: 'talent-pool',
    params: { locationId: props.entityId },
  });
};
</script>

<style scoped lang="scss">
.title-bar {
  padding: 1.5rem 2rem;
  border-bottom: 1px solid var(--palette-color-default-lighten-90);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title-bar .title {
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: -0.48px;
}

.title-bar .exit-btn {
  background: none;
  border: 0;
  cursor: pointer;
}

.title-bar .exit-btn .icon {
  font-size: 1.5rem;
}

.breadcrumb-item .breadcrumb-name {
  color: var(--palette-color-default-lighten-30);
  transition: 0.2s;

  &.router-link-active {
    color: var(--palette-color-core-1);
    cursor: default;
  }

  &:not(.router-link-active):hover {
    color: var(--palette-color-default);
  }
}

.to-dashboard {
  display: flex;
  align-items: center;
  gap: 10px;

  .arrow {
    font-size: 18px;
  }
}
</style>
